var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclineCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17035 15.5794C8.98035 15.5794 8.79035 15.5094 8.64035 15.3594C8.35035 15.0694 8.35035 14.5894 8.64035 14.2994L14.3004 8.63938C14.5904 8.34938 15.0704 8.34938 15.3604 8.63938C15.6504 8.92937 15.6504 9.40937 15.3604 9.69937L9.70035 15.3594C9.56035 15.5094 9.36035 15.5794 9.17035 15.5794Z",
    fill: "#0D2645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8304 15.5794C14.6404 15.5794 14.4504 15.5094 14.3004 15.3594L8.64035 9.69937C8.35035 9.40937 8.35035 8.92937 8.64035 8.63938C8.93035 8.34938 9.41035 8.34938 9.70035 8.63938L15.3604 14.2994C15.6504 14.5894 15.6504 15.0694 15.3604 15.3594C15.2104 15.5094 15.0204 15.5794 14.8304 15.5794Z",
    fill: "#0D2645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#0D2645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineCount);
export default __webpack_public_path__ + "static/media/decline-count.4d66b443ea3947a8e042da6447e7aba3.svg";
export { ForwardRef as ReactComponent };